import { AutoComplete, Col, Form, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import { Button, SelectForm } from 'components';
import { useEffect, useState } from 'react';
import { icons } from 'utils/constants/icons';

interface IApprovalLevelProps {
  level: number;
}

const { PlusOutlined, CloseOutlined } = icons;

const ApprovalLevel = ({ level }: IApprovalLevelProps) => {
  const [isFirst, setIsFirst] = useState(true);
  const [emailCount, setEmailCount] = useState(1);

  const handleOnclick = (index: number) => {
    if (index) {
      setEmailCount(emailCount - 1);

      return;
    }

    setEmailCount(emailCount + 1);
  };

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
    }
  }, [isFirst]);

  return (
    <div className={level > 1 ? 'mt-[18px]' : ''}>
      <Title level={5}>Cấp {level}</Title>
      <Row className="mt-5 gap-y-5" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12} className="h-[80px]">
          <Form.Item
            rules={[isFirst ? {} : { required: true }]}
            // required
            label="Phê duyệt"
            name={`level-${level}-approval`}
          >
            <SelectForm
              className="text-red"
              placeholder="Chọn phê duyệt"
              options={[
                {
                  value: 'sequentially',
                  label: 'Tuần tự',
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={12} className="h-[80px]"></Col>
        {new Array(emailCount).fill(0).map((_, index) => (
          <Col key={index} span={12} className="h-[80px]">
            <div className="flex gap-2 items-center">
              <Form.Item
                className="flex-1"
                label="Email"
                name={`level-${level}-email-${index}`}
                rules={[
                  {
                    type: 'email',
                    message: 'Email không hợp lệ',
                  },
                ]}
              >
                {/* <InputForm
                onKeyDown={handleKeyDown}
                placeholder="Nhập số điện thoại"
              /> */}
                <AutoComplete
                  size="large"
                  // options={dataFilterPhone.map((item: any) => ({
                  //   value: item.phone,
                  //   label: item.phone,
                  //   key: item.id,
                  // }))}
                  // onSearch={getAllCusFilterPhone}
                  // onSelect={(value) => {
                  //   getAllCusFilterPhone(value);
                  //   onFinish(form.getFieldsValue());
                  // }}
                  placeholder="Nhập email"
                />
              </Form.Item>
              <Button
                type="button"
                title={
                  index ? (
                    <CloseOutlined className="text-[rgba(220,_54,_46,_1)]" />
                  ) : (
                    <PlusOutlined />
                  )
                }
                customClass="w-[40px] h-[40px]"
                handleOnclick={() => handleOnclick(index)}
              />
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ApprovalLevel;
